<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
        <div class="-two-columns">
            <div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>

            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Ressources</h1>
                        <Listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            :deletedShowable="true"
                            @set-show-deleted="showDeleted = $event"
                            :showDeleted="showDeleted"
                            @set-search-text="setSearchText('searchCompanyText', $event)"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else-if="form.id">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h1 class="o-form__title">Ressources</h1> -->
                            <input
                                type="hidden"
                                name="id"
                                v-model="form.id"
                                v-if="form.id"
                            >
                            <div class="o-form__item">
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder="Nom de la ressource"
                                    label="Nom de la ressource"
                                    v-model="form.name"
                                    required=true
                                    error-message="Ce champ est requis"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <!-- <q-checkbox size="sm" v-model="form.tracked" label="Suivre la disponibilité - toDo" /> -->
                            </div>
                            <div class="o-form__item">
                                <Select
                                    v-model="form.type"
                                    :options="typeOptions"
                                    :clearable="true"
                                    label="Type de ressource"
                                    placeholder="Choisir type de resource"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Select
                                    v-model="form.applyTo"
                                    :options="applyToOptions"
                                    :clearable="false"
                                    required
                                    label="Attribut de ..."
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    type="textarea"
                                    v-model="form.description"
                                    placeholder="Description"
                                    label="Description"
                                    autogrow
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <!-- <div class="o-form__item -button -multiple">
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="form.id">Sauvegarder</button>
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="!form.id">Ajouter</button>
                            </div> -->
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { RESOURCES, RESOURCETYPES, RESOURCESSEARCH } from '@/graphql/resource/queries'
    import { APPLYTOMODELS } from '@/graphql/tag/queries'
    import { UPSERTRESOURCE, DELETERESOURCE, RESTORERESOURCE } from '@/graphql/resource/mutations'
    // import { removeNULL } from '@/js/utilities'

    export default {
        name: "Resources",
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: 'Copier',
                    searchableQL: 'Rechercher / filtrer'
                },
                searchContactText: null,
                form: {},
                applyToOptions: [],
                newItem: {
                    id: 0,
                    name: null,
                    // type: "OTHER",
                    description: null,
                    tracked: false
                },
                typeOptions: [],
                showDeleted: false,
                perPage: 50,
            }
        },
        mounted: async function(){
            this.setNewItem()
        },
        computed: {
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
        },
        methods: {

            setSearchText(prop, searchText) {
                this.setSelected(this.newItem);
                if (searchText && searchText.length > 1) searchText = searchText.trim().split(" ").join("* ") + "*";
                this.fetchSearchText(searchText);
            },

            async fetchSearchText(searchText) {

                if (searchText && searchText != "") {
                    let search = searchText.trim().split(" ").join("* ") + "*";
                    search = search.replace(/\*\*/g, '*');

                    // Vérifier si la query existe déjà
                    if (this.$apollo.queries.resourcesSearch) {
                        // Mettre à jour les variables et refetch
                        this.$apollo.queries.resourcesSearch.setVariables({
                            searchText: search,
                            first: this.perPage
                        });
                        this.$apollo.queries.resourcesSearch.refetch();
                    } else {
                        // Ajouter la query seulement si elle n'existe pas
                        this.$apollo.addSmartQuery('resourcesSearch', {
                            query: RESOURCESSEARCH,
                            fetchPolicy: 'network-only',
                            error(error) {
                                if (error.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: error.message });
                            },
                            variables: {
                                searchText: search,
                                // trashed: this.trashed,
                                first: this.perPage
                            },
                            update(resourcesSearch) {
                                this.listbox.listItems = Object.assign([], resourcesSearch.resourcesSearch.data)
                                return resourcesSearch;
                            },
                        })
                    }
                } else {
                    this.$apollo.queries.resources.refresh()
                }
            },


            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form=Object.assign({}, item);
            },
            setNewItem(){
                this.listbox.selectedItem=Object.assign({}, this.newItem);
                this.form = Object.assign({}, this.newItem);
                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETERESOURCE,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.resources) this.$apollo.queries.resources.refetch()
                        this.setSelected(null);
                    }
                })
                this.setNewItem();
            },
            saveItem(form) {
                // form=removeNULL(form);
                if(form.type) {
                    form.typeID=form.type.id
                }else{
                    form.disconnectType=true
                }
                this.$apollo.mutate({
                    mutation: UPSERTRESOURCE,
                    variables: { ...form },
                    update: (store, { data: { upsertResource } }) => {
                        if (!form.id) {
                            let myVariables = { trashed: this.trashed, first: this.perPage }
                            const data = store.readQuery({ query: RESOURCES, variables: myVariables })
                            data.resources.data.push(upsertResource);
                            store.writeQuery({
                                query: RESOURCES,
                                data,
                            })
                        }
                        this.setSelected(upsertResource)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Ressource : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORERESOURCE,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { restoreResource } }) => {
                        if(!form.id){
                            const data = store.readQuery({ query: RESOURCES })
                            data.resources.push(restoreResource);
                            store.writeQuery({
                                query: RESOURCES,
                                data,
                            })
                        }
                        this.setSelected(restoreResource)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Ressource : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            },
        },
        apollo: {
            applyToModels: {
                query: APPLYTOMODELS,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data) {
                    this.applyToOptions=[];
                    data.__type.enumValues.forEach(function(item){
                        this.applyToOptions.push(item.name)
                    }.bind(this))
                    // return data.__type.enumValues
                }
            },
            resourceTypes: {
                query: RESOURCETYPES,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data) {
                    this.typeOptions=[];
                    data.resourceTypes.forEach(function(item){
                        item.label=item.name
                        item.value=item.id
                        this.typeOptions.push(item)
                    }.bind(this))
                }
            },
            resources: {
                query: RESOURCES,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        trashed: this.trashed,
                        first: this.perPage,
                    }
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(resources) {
                    this.listbox.listItems = Object.assign([], resources.resources.data)
                    return resources.resources.data;
                }
            }
        }
    }
</script>